export const cookingTemperatureQueryKeys = {
  all: ['cooking-temperature'] as const,
  records: (date: string) => ['cooking-temperature', 'records', date] as const,
  calendar: (from: string, to: string) => ['cooking-temperature', 'calendar', from, to] as const,
};
